__turbopack_context__.v({
  "page-body-wrap": "SL6mta_page-body-wrap",
  "paragraph-content": "SL6mta_paragraph-content",
  "wrap-container": "SL6mta_wrap-container",
  "wrap-content": "SL6mta_wrap-content",
});
